module.exports = __webpack_public_path__ + "static/media/filter.32788688.svg";